import { render, staticRenderFns } from "./CardGroup.vue?vue&type=template&id=6d2b5d30&scoped=true&"
import script from "./CardGroup.vue?vue&type=script&lang=js&"
export * from "./CardGroup.vue?vue&type=script&lang=js&"
import style0 from "./CardGroup.vue?vue&type=style&index=0&id=6d2b5d30&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2b5d30",
  null
  
)

export default component.exports